import Reveal from "@/components/site/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Fast Response",
    body: "Call in the morning, clutter-free by evening. We pride ourselves on same-day and next-day pickups across Payne, Noble, Pawnee, Creek, and Logan counties — because junk shouldn't wait.",
  },
  {
    num: "02",
    title: "Fair & Upfront Pricing",
    body: "You get an honest quote before we lift a thing. No hidden fees, no surprises on the invoice — just affordable rates that respect your budget.",
  },
  {
    num: "03",
    title: "Recycle & Donate First",
    body: "We care about our community and the environment. Usable items are donated and materials recycled whenever possible — keeping good stuff out of landfills and giving it a second life.",
  },
  {
    num: "04",
    title: "No Job Too Big or Small",
    body: "From a single couch pickup to a full estate clean-out, shed demolition to hot tub removal — if it's junk to you, it's a job for us.",
  },
  {
    num: "05",
    title: "On Time. Every Time.",
    body: "A reliable partner who shows up when promised, works hard, and leaves your space spotless. That's the GW standard.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36"
    >
      <Reveal>
        <p className="font-mono-ind text-xs uppercase tracking-[0.3em] text-[#FF9F00]">
          The GW Standard
        </p>
        <h2 className="mt-4 font-display text-5xl leading-none tracking-tight sm:text-7xl">
          WHY PAYNE COUNTY <span className="text-stroke-orange">CALLS US</span>
        </h2>
      </Reveal>

      <div className="mt-16">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.05}>
            <div
              data-testid={`manifesto-chapter-${c.num}`}
              className="group grid grid-cols-[auto_1fr] items-start gap-6 border-t border-[#282C34] py-10 transition-colors duration-500 hover:bg-[#14171C]/60 sm:grid-cols-[120px_1fr_2fr] sm:gap-12 sm:px-6"
            >
              <span className="font-display text-5xl text-[#FF5A00]/40 transition-colors duration-500 group-hover:text-[#FF5A00] sm:text-6xl">
                {c.num}
              </span>
              <h3 className="font-display text-3xl tracking-wide text-zinc-100 sm:text-4xl">
                {c.title}
              </h3>
              <p className="col-span-2 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:col-span-1 sm:text-base">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-[#282C34]" />
      </div>
    </section>
  );
}
